
import React from 'react';
import { Button } from '@/components/ui/button';
import { Edit, Trash2, Eye, RefreshCw } from 'lucide-react';

interface Profile {
  id: string;
  email: string;
  first_name: string;
  last_name: string;
  role: 'superadmin' | 'member';
  created_at: string;
}

interface UserActionsCellProps {
  user: Profile;
  onEdit: (user: Profile) => void;
  onDelete: (user: Profile) => void;
  onImpersonate: (user: Profile) => void;
  impersonatingUserId: string | null;
}

export const UserActionsCell = ({
  user,
  onEdit,
  onDelete,
  onImpersonate,
  impersonatingUserId
}: UserActionsCellProps) => {
  return (
    <div className="space-x-2">
      <Button
        variant="ghost"
        size="sm"
        onClick={() => onEdit(user)}
      >
        <Edit className="h-4 w-4" />
      </Button>
      
      <Button
        variant="ghost"
        size="sm"
        onClick={() => onDelete(user)}
        className="text-red-600 hover:text-red-700"
      >
        <Trash2 className="h-4 w-4" />
      </Button>

      {user.role === 'member' && (
        <Button
          variant="ghost"
          size="sm"
          onClick={() => onImpersonate(user)}
          disabled={impersonatingUserId === user.id}
          className="text-blue-600 hover:text-blue-700"
        >
          {impersonatingUserId === user.id ? (
            <RefreshCw className="h-4 w-4 animate-spin" />
          ) : (
            <Eye className="h-4 w-4" />
          )}
        </Button>
      )}
    </div>
  );
};
